import { type ErrorFlow, type SeverityLevel, logError, logErrorFactory } from './logError';

export { logError, logErrorFactory };
export type { ErrorFlow, SeverityLevel };
